var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{style:('width:' + _vm.width + '%; min-width:' + _vm.width + '%; max-width:' + _vm.width + '%; text-align:' + _vm.textAlign),attrs:{"colspan":_vm.colspan}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }